const homePageVideo = document.getElementById('intro-video');

const initHomePageVideoInteractions = () => {
  handleSoundControlClicked();
  onVideoLoaded();
};

const initPageAfterLoading = () => {
  document.querySelector('body').classList.add('initialized');
};

const onVideoLoaded = () => {
  homePageVideo.preload = "auto";
  const isPlayTypeAllowedByBrowser = homePageVideo.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
  homePageVideo.addEventListener('canplay', initPageAfterLoading);
  // Instantly remove loading screen for browsers who can't play current video
  if (!isPlayTypeAllowedByBrowser || isPlayTypeAllowedByBrowser === "maybe") {
    initPageAfterLoading();
  } else {
    setTimeout(initPageAfterLoading, 2000);
  }
};

const handleSoundControlClicked = () => {
  const controlSection = document.querySelector('.controls');
  if (!controlSection) {
    return;
  }
  controlSection.addEventListener('click', () => {
    controlSection.querySelectorAll('span').forEach(icon => {
      icon.classList.toggle('hidden');
    });
    homePageVideo.muted = !homePageVideo.muted;
  });
};

homePageVideo && initHomePageVideoInteractions();
